const ApiURL = import.meta.env.VITE_REACT_APP_API_BASE_URL || import.meta.env.VITE_REACT_APP_AUTH0_AUDIENCE;

export default ApiURL;
